(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AA-guide-theme-2"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  class CartPageManager {
    constructor() {
      this.root = document.querySelector('[data-cart-page-root]');
      if (!this.root) return;

      this.onClick = this.onClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      document.addEventListener('click', this.onClick);
      document.addEventListener('submit', this.onSubmit);

      window.CartDrawerManager?.restoreShippingState();
    }

    onClick(event) {
      if (!event.target.closest('[data-cart-page-root]')) return;

      const removeDiscountBtn = event.target.closest('[data-cart-discount-remove]');
      if (removeDiscountBtn) {
        this.removeDiscount(removeDiscountBtn);
        return;
      }

      const removeBtn = event.target.closest('[data-remove-item]');
      if (removeBtn) {
        const key = removeBtn.dataset.lineItemKey;
        if (key) this.updateCart(() => window.CartManager?.remove(key, { button: removeBtn }));
        return;
      }

      const minusBtn = event.target.closest('[data-quantity-minus]');
      if (minusBtn) {
        const key = minusBtn.dataset.lineItemKey;
        const qty = this.getQuantity(minusBtn);
        if (!key) return;
        if (qty <= 1) {
          this.updateCart(() => window.CartManager?.remove(key, { button: minusBtn }));
        } else {
          this.updateCart(() => window.CartManager?.update(key, qty - 1, { button: minusBtn }));
        }
        return;
      }

      const plusBtn = event.target.closest('[data-quantity-plus]');
      if (plusBtn) {
        const key = plusBtn.dataset.lineItemKey;
        const qty = this.getQuantity(plusBtn);
        if (key) this.updateCart(() => window.CartManager?.update(key, qty + 1, { button: plusBtn }));
      }
    }

    async onSubmit(event) {
      if (!event.target.closest('[data-cart-page-root]')) return;

      const shippingForm = event.target.closest('[data-cart-shipping-form]');
      if (shippingForm) {
        event.preventDefault();
        await this.handleShippingSubmit(shippingForm);
        return;
      }
    }

    getQuantity(btn) {
      const item = btn.closest('[data-cart-item]');
      const valueEl = item?.querySelector('[data-quantity-value]');
      return parseInt(valueEl?.textContent?.trim() || '1', 10);
    }

    async updateCart(action) {
      const result = await action();
      if (result?.success) {
        window.location.reload();
      }
    }

    async handleShippingSubmit(form) {
      await window.CartDrawerManager?.calculateShipping(form);
    }



    async removeDiscount(button) {
      const result = await window.CartManager?.removeDiscount({ button });
      if (result?.success) {
        window.location.reload();
      }
    }

  }

  const initCartPage = () => {
    if (!window.CartPageManager) {
      window.CartPageManager = new CartPageManager();
    } else {
      window.CartPageManager.root = document.querySelector('[data-cart-page-root]');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo-metaobject"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const handleToggle = (toggle) => {
      const root = toggle.closest('[data-seo-root]');
      const seoSection = toggle.closest('.collectionSeo');

      if (!root || !seoSection) return;

      const startHeight = seoSection.getBoundingClientRect().height;

      if (seoSection.collectionSeoToggleAnimation) {
        seoSection.collectionSeoToggleAnimation.cancel();
      }

      const isExpanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      toggle.textContent = isExpanded ? 'Clique aqui para ver menos' : 'Clique aqui para ver mais';

      const endHeight = seoSection.getBoundingClientRect().height;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || Math.abs(endHeight - startHeight) < 1) return;

      const animation = seoSection.animate(
        [
          { height: `${startHeight}px` },
          { height: `${endHeight}px` },
        ],
        {
          duration: 240,
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        }
      );

      seoSection.collectionSeoToggleAnimation = animation;

      const finishAnimation = () => {
        if (seoSection.collectionSeoToggleAnimation !== animation) return;

        seoSection.collectionSeoToggleAnimation = undefined;
      };

      animation.addEventListener('finish', finishAnimation, { once: true });
      animation.addEventListener('cancel', finishAnimation, { once: true });
    };

    document.querySelectorAll('[data-seo-toggle]').forEach((toggle) => {
      if (toggle.dataset.seoReady === 'true') return;

      toggle.dataset.seoReady = 'true';

      toggle.addEventListener('click', () => {
        handleToggle(toggle);
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.collectionSlider .splide[data-splide-component="collection-slider"]';

    const updateProgressVisibility = (scope = document) => {
      const sliders = scope.matches?.(selector)
        ? [scope]
        : Array.from(scope.querySelectorAll?.(selector) || []);

      sliders.forEach((slider) => {
        const progress = slider.closest('.collectionSlider')?.querySelector('[data-collection-slider-progress]');
        const track = slider.querySelector('.splide__track');
        const list = slider.querySelector('.splide__list');

        if (!progress || !track || !list) return;

        const hasOverflow = slider.classList.contains('is-overflow') || list.scrollWidth > track.clientWidth + 1;

        if (!hasOverflow) {
          progress.setAttribute('hidden', 'hidden');
        } else {
          progress.removeAttribute('hidden');
        }
      });
    };

    const boot = () => {
      window.setTimeout(() => updateProgressVisibility(), 0);
      window.addEventListener('resize', () => {
        window.setTimeout(() => updateProgressVisibility(), 0);
      });
      document.addEventListener('shopify:section:load', (event) => {
        window.setTimeout(() => updateProgressVisibility(event.target), 0);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
    (() => {
      const getLoadedProductCount = (section) => {
        let total = 0;

        section.querySelectorAll('[data-collection-page-group]').forEach((group) => {
          total += group.querySelectorAll('.collectionPage__gridItem').length;
        });

        return total;
      };

      const updateCollectionCount = (section) => {
        if (!section) return;

        const countElement = section.querySelector('[data-plp-count]');
        if (!countElement) return;

        const count = getLoadedProductCount(section);
        section.dataset.plpTotalResults = String(count);
        countElement.textContent = `${count} ${count === 1 ? 'produto' : 'produtos'}`;
        document.dispatchEvent(new CustomEvent('collection:count-updated', {
          detail: { count },
        }));
      };

      const init = () => {
        document.querySelectorAll('[data-collection-page]').forEach(updateCollectionCount);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
      } else {
        init();
      }

      document.addEventListener('collection:updated', () => {
        updateCollectionCount(document.querySelector('[data-collection-page]'));
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcementBar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-announcement-bar]';
    let layoutUpdateScheduled = false;
    let lastHeight = null;

    const updateAnnouncementBarLayout = () => {
      const bars = Array.from(document.querySelectorAll(selector)).filter((bar) => {
        return Boolean(bar.closest('.shopify-section-group-header-group'));
      });
      const height = bars.reduce((total, bar) => total + bar.offsetHeight, 0);
      const headers = Array.from(
        document.querySelectorAll('.shopify-section-group-header-group [data-header]')
      ).map((header) => ({
        element: header,
        isFixed: getComputedStyle(header).position === 'fixed'
      }));
      const mobileCompensation = window.matchMedia('(max-width: 749px)').matches ? 2 : 0;
      const fixedHeaderTop = `${Math.max(0, height - mobileCompensation)}px`;

      if (height !== lastHeight) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
        document.documentElement.style.setProperty('--top-bar-height', `${height}px`);
        lastHeight = height;
      }

      headers.forEach(({ element, isFixed }) => {
        if (isFixed) {
          if (element.style.top !== fixedHeaderTop) element.style.setProperty('top', fixedHeaderTop);
        } else {
          if (element.style.top) element.style.removeProperty('top');
        }
      });
    };

    const scheduleAnnouncementBarLayout = () => {
      if (layoutUpdateScheduled) return;
      layoutUpdateScheduled = true;

      window.requestAnimationFrame(() => {
        layoutUpdateScheduled = false;
        updateAnnouncementBarLayout();
      });
    };

    const init = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(scheduleAnnouncementBarLayout);
        resizeObserver.observe(root);
        root.announcementBarResizeObserver = resizeObserver;
      }

      const sliderElement = root.querySelector('.announcementBar__slider');
      const slideCount = root.querySelectorAll('.announcementBar__slide').length;
      if (!sliderElement || slideCount === 0) return;

      const mount = () => {
        if (typeof Splide === 'undefined') {
          window.setTimeout(mount, 50);
          return;
        }

        const slider = new Splide(sliderElement, {
          type: slideCount > 1 ? 'loop' : 'slide',
          perPage: 1,
          arrows: false,
          pagination: false,
          drag: true,
          autoplay: root.dataset.autoRotate === 'true' && slideCount > 1,
          interval: Number(root.dataset.interval) || 5000,
          pauseOnHover: true,
          pauseOnFocus: true,
          rewind: true
        });
        slider.mount();
        sliderElement.splide = slider;
        scheduleAnnouncementBarLayout();
      };

      mount();
    };

    document.querySelectorAll(selector).forEach(init);
    scheduleAnnouncementBarLayout();
    window.addEventListener('load', scheduleAnnouncementBarLayout, { once: true });
    window.addEventListener('resize', scheduleAnnouncementBarLayout, { passive: true });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        const root = event.target.querySelector(selector);
        if (!root) return;
        init(root);
        scheduleAnnouncementBarLayout();
      });
      document.addEventListener('shopify:block:select', scheduleAnnouncementBarLayout);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-signup-modal"] && !Shopify.designMode) return;
  try {
    
    (() => {
      document.querySelectorAll('[data-signup-modal]').forEach((root) => {
        if (root.dataset.initialized === 'true') return;

        root.dataset.initialized = 'true';

        const storageKey = root.dataset.storageKey;
        const closeButtons = root.querySelectorAll('[data-signup-modal-close]');
        const successState = root.querySelector('[data-signup-modal-success]');
        const delayMs = Number(root.dataset.delaySeconds || 0) * 1000;
        const designMode = root.dataset.designMode === 'true';

        const openModal = () => {
          root.hidden = false;
          document.body.style.overflow = 'hidden';
        };

        const closeModal = () => {
          root.hidden = true;
          document.body.style.overflow = '';
          localStorage.setItem(storageKey, 'dismissed');
        };

        closeButtons.forEach((button) => {
          button.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !root.hidden) {
            closeModal();
          }
        });

        if (successState) {
          localStorage.setItem(storageKey, 'submitted');
          openModal();
          return;
        }

        if (designMode) {
          openModal();
          return;
        }

        const currentState = localStorage.getItem(storageKey);
        if (currentState === 'dismissed' || currentState === 'submitted') {
          return;
        }

        window.setTimeout(openModal, delayMs);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-top-bar"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const TOP_BAR_SELECTOR = '[data-top-bar]';

      const getFixedTopBars = () => {
        return Array.from(document.querySelectorAll(TOP_BAR_SELECTOR)).filter((bar) => {
          return Boolean(bar.closest('.shopify-section-group-header-group'));
        });
      };

      const updateTopBarsLayout = () => {
        const fixedBars = getFixedTopBars();
        let accumulatedHeight = 0;

        fixedBars.forEach((bar) => {
          bar.style.top = `${accumulatedHeight}px`;
          accumulatedHeight += bar.offsetHeight;
        });

        document.documentElement.style.setProperty('--top-bar-height', `${accumulatedHeight}px`);
      };

      document.querySelectorAll('[data-top-bar]').forEach((root) => {
        if (root.dataset.initialized === 'true') return;

        root.dataset.initialized = 'true';

        const updateCountdown = (countdown) => {
          const endValue = countdown.dataset.countdownEnd;
          const normalizedEndValue = endValue.includes('T') ? endValue : endValue.replace(' ', 'T');
          const targetDate = new Date(normalizedEndValue);

          if (Number.isNaN(targetDate.getTime())) {
            countdown.hidden = true;
            updateTopBarsLayout();
            return;
          }

          const now = new Date();
          const diff = targetDate.getTime() - now.getTime();

          if (diff <= 0) {
            countdown.hidden = true;
            updateTopBarsLayout();
            return;
          }

          const totalMinutes = Math.floor(diff / 60000);
          const days = Math.floor(totalMinutes / 1440);
          const hours = Math.floor((totalMinutes % 1440) / 60);
          const minutes = totalMinutes % 60;

          const daysNode = countdown.querySelector('[data-countdown-days]');
          const hoursNode = countdown.querySelector('[data-countdown-hours]');
          const minutesNode = countdown.querySelector('[data-countdown-minutes]');

          if (daysNode) daysNode.textContent = String(days).padStart(2, '0');
          if (hoursNode) hoursNode.textContent = String(hours).padStart(2, '0');
          if (minutesNode) minutesNode.textContent = String(minutes).padStart(2, '0');
        };

        const countdowns = Array.from(root.querySelectorAll('[data-countdown]'));
        countdowns.forEach((countdown) => updateCountdown(countdown));

        if (countdowns.length) {
          window.setInterval(() => {
            countdowns.forEach((countdown) => updateCountdown(countdown));
            updateTopBarsLayout();
          }, 1000);
        }

        updateTopBarsLayout();
        window.addEventListener('resize', updateTopBarsLayout);

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            if (!root.contains(event.target)) return;

            window.setTimeout(updateTopBarsLayout, 50);
          });
        }
      });

      window.setTimeout(updateTopBarsLayout, 50);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["institutional-sidebar-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.institutionalSidebarPage[data-store-directory="true"]').forEach((section) => {
    const stateSelect = section.querySelector('[data-store-state-filter]');
    const citySelect = section.querySelector('[data-store-city-filter]');
    const cards = Array.from(section.querySelectorAll('[data-store-card]'));
    const emptyState = section.querySelector('[data-store-empty]');

    if (!stateSelect || !citySelect || cards.length === 0) {
      return;
    }

    const makeOption = (value, label) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = label;
      return option;
    };

    const populateCities = (selectedState) => {
      const cities = [];
      const seen = new Set();

      citySelect.innerHTML = '';
      citySelect.appendChild(makeOption('', 'Cidade'));

      if (!selectedState) {
        citySelect.disabled = true;
        return;
      }

      cards.forEach((card) => {
        if (card.dataset.state !== selectedState) {
          return;
        }

        const cityValue = card.dataset.city || '';
        const cityLabel = card.querySelector('.institutionalSidebarPage__storeMeta span:last-child')?.textContent?.trim() || '';

        if (!cityValue || !cityLabel || seen.has(cityValue)) {
          return;
        }

        seen.add(cityValue);
        cities.push({ value: cityValue, label: cityLabel });
      });

      cities.sort((firstCity, secondCity) => firstCity.label.localeCompare(secondCity.label, 'pt-BR'));
      cities.forEach((city) => citySelect.appendChild(makeOption(city.value, city.label)));
      citySelect.disabled = cities.length === 0;
    };

    const applyFilters = () => {
      const selectedState = stateSelect.value;
      const selectedCity = citySelect.value;
      let visibleCards = 0;

      cards.forEach((card) => {
        let matchesState = true;
        let matchesCity = true;

        if (selectedState) {
          matchesState = card.dataset.state === selectedState;
        }

        if (selectedCity) {
          matchesCity = card.dataset.city === selectedCity;
        }

        const isVisible = matchesState && matchesCity;
        card.hidden = !isVisible;

        if (isVisible) {
          visibleCards += 1;
        }
      });

      emptyState.hidden = visibleCards > 0;
    };

    stateSelect.addEventListener('change', () => {
      populateCities(stateSelect.value);
      citySelect.value = '';
      applyFilters();
    });

    citySelect.addEventListener('change', applyFilters);

    populateCities(stateSelect.value);
    applyFilters();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-hotspots"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-lookbook-root]';
    const hotspotSelector = '[data-lookbook-hotspot]';
    const buttonSelector = '[data-lookbook-hotspot-button]';
    const panelSelector = '[data-lookbook-hotspot-panel]';
    const finePointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    class LookbookHotspots {
      constructor(root) {
        this.root = root;
        this.boundOnPointerDown = this.onPointerDown.bind(this);
        this.boundOnClick = this.onClick.bind(this);
        this.boundOnPointerOver = this.onPointerOver.bind(this);
        this.boundOnPointerLeave = this.onPointerLeave.bind(this);
        this.boundOnDocumentClick = this.onDocumentClick.bind(this);
        this.boundOnResize = this.onResize.bind(this);
        this.boundOnBlockSelect = this.onBlockSelect.bind(this);
        this.mount();
      }

      mount() {
        if (this.root.dataset.lookbookMounted === 'true') return;
        this.root.dataset.lookbookMounted = 'true';

        this.root.addEventListener('click', this.boundOnClick);
        this.root.addEventListener('pointerdown', this.boundOnPointerDown);
        this.root.addEventListener('pointerover', this.boundOnPointerOver);
        this.root.addEventListener('pointerleave', this.boundOnPointerLeave, true);
        document.addEventListener('click', this.boundOnDocumentClick);
        document.addEventListener('shopify:block:select', this.boundOnBlockSelect);
        window.addEventListener('resize', this.boundOnResize);
      }

      onPointerDown(event) {
        if (finePointerQuery.matches) return;

        const button = event.target.closest(buttonSelector);
        if (!button || !this.root.contains(button)) return;

        event.preventDefault();
      }

      onClick(event) {
        const button = event.target.closest(buttonSelector);
        if (!button || !this.root.contains(button)) return;

        const hotspot = button.closest(hotspotSelector);
        if (!hotspot) return;

        event.preventDefault();
        event.stopPropagation();
        button.blur();

        if (hotspot.dataset.state === 'pinned') {
          this.closeHotspot(hotspot);
          return;
        }

        this.closeOthers(hotspot);
        this.openHotspot(hotspot, 'pinned');
      }

      onPointerOver(event) {
        if (!finePointerQuery.matches) return;

        const hotspot = event.target.closest(hotspotSelector);
        if (!hotspot || !this.root.contains(hotspot)) return;
        if (hotspot.dataset.state === 'pinned') return;

        this.closeOthers(hotspot);
        this.openHotspot(hotspot, 'preview');
      }

      onPointerLeave(event) {
        if (!finePointerQuery.matches) return;

        const hotspot = event.target.closest(hotspotSelector);
        if (!hotspot || !this.root.contains(hotspot)) return;
        if (hotspot.dataset.state === 'pinned') return;

        const relatedTarget = event.relatedTarget;
        if (relatedTarget && hotspot.contains(relatedTarget)) return;

        this.closeHotspot(hotspot);
      }

      onDocumentClick(event) {
        if (this.root.contains(event.target)) return;
        this.closeAll();
      }

      onResize() {
        this.root.querySelectorAll(`${hotspotSelector}[data-state="preview"], ${hotspotSelector}[data-state="pinned"]`).forEach((hotspot) => {
          this.positionPanel(hotspot);
        });
      }

      onBlockSelect(event) {
        const target = event.target.closest(hotspotSelector);
        if (!target || !this.root.contains(target)) return;

        this.closeOthers(target);
        this.openHotspot(target, 'pinned');
      }

      openHotspot(hotspot, state) {
        const panel = hotspot.querySelector(panelSelector);
        const button = hotspot.querySelector(buttonSelector);
        if (!panel || !button) return;

        hotspot.dataset.state = state;
        button.setAttribute('aria-expanded', 'true');
        panel.hidden = false;

        window.requestAnimationFrame(() => this.positionPanel(hotspot));
      }

      closeHotspot(hotspot) {
        const panel = hotspot.querySelector(panelSelector);
        const button = hotspot.querySelector(buttonSelector);
        if (!panel || !button) return;

        hotspot.dataset.state = 'closed';
        hotspot.dataset.placement = '';
        button.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      }

      closeOthers(exceptHotspot) {
        this.root.querySelectorAll(hotspotSelector).forEach((hotspot) => {
          if (hotspot === exceptHotspot) return;
          this.closeHotspot(hotspot);
        });
      }

      closeAll() {
        this.root.querySelectorAll(hotspotSelector).forEach((hotspot) => this.closeHotspot(hotspot));
      }

      positionPanel(hotspot) {
        const panel = hotspot.querySelector(panelSelector);
        if (!panel || panel.hidden) return;

        panel.style.setProperty('--lookbook-panel-shift-x', '0px');
        panel.style.setProperty('--lookbook-panel-shift-y', '0px');
        hotspot.dataset.placement = 'right';
        const hotspotRect = hotspot.getBoundingClientRect();
        const viewportPadding = 16;
        const gap = window.innerWidth < 990 ? 8 : 12;
        const isMobile = window.innerWidth < 990;
        const bounds = {
          left: viewportPadding,
          right: window.innerWidth - viewportPadding,
          top: viewportPadding,
          bottom: window.innerHeight - viewportPadding
        };
        const spaceRight = bounds.right - hotspotRect.right;
        const spaceLeft = hotspotRect.left - bounds.left;
        const spaceBottom = bounds.bottom - hotspotRect.bottom;
        const spaceTop = hotspotRect.top - bounds.top;

        const preferred = hotspot.dataset.preferredSide || 'auto';
        let placements = preferred === 'auto'
          ? ['right', 'left', 'bottom', 'top']
          : [preferred, 'right', 'left', 'bottom', 'top'];

        if (isMobile) {
          if (preferred === 'auto') {
            placements = ['bottom', 'top', 'right', 'left'];
          } else {
            placements = [preferred, 'bottom', 'top', 'right', 'left'];
          }
        }

        let chosenPlacement = placements[0];
        const panelWidth = Math.min(320, window.innerWidth - (viewportPadding * 2));
        const measurePanelHeight = () => panel.getBoundingClientRect().height;

        placements.some((placement) => {
          const panelHeight = measurePanelHeight();

          if (placement === 'right' && spaceRight >= panelWidth + gap) {
            chosenPlacement = placement;
            return true;
          }

          if (placement === 'left' && spaceLeft >= panelWidth + gap) {
            chosenPlacement = placement;
            return true;
          }

          if (placement === 'bottom' && spaceBottom >= panelHeight + gap) {
            chosenPlacement = placement;
            return true;
          }

          if (placement === 'top' && spaceTop >= panelHeight + gap) {
            chosenPlacement = placement;
            return true;
          }

          return false;
        });

        hotspot.dataset.placement = chosenPlacement;
        const panelRect = panel.getBoundingClientRect();
        let shiftX = 0;
        let shiftY = 0;

        if (panelRect.left < bounds.left) {
          shiftX += bounds.left - panelRect.left;
        } else if (panelRect.right > bounds.right) {
          shiftX -= panelRect.right - bounds.right;
        }

        if (panelRect.top < bounds.top) {
          shiftY += bounds.top - panelRect.top;
        } else if (panelRect.bottom > bounds.bottom) {
          shiftY -= panelRect.bottom - bounds.bottom;
        }

        if (isMobile && chosenPlacement !== 'left' && chosenPlacement !== 'right') {
          shiftY = 0;
        }

        panel.style.setProperty('--lookbook-panel-shift-x', `${Math.round(shiftX)}px`);
        panel.style.setProperty('--lookbook-panel-shift-y', `${Math.round(shiftY)}px`);
      }
    }

    const mountAll = (scope = document) => {
      const roots = scope.matches?.(rootSelector)
        ? [scope]
        : Array.from(scope.querySelectorAll?.(rootSelector) || []);

      roots.forEach((root) => new LookbookHotspots(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => mountAll());
    } else {
      mountAll();
    }

    document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.productSlider .splide[data-splide-component="product-slider"]';
    const recommendationsSelector = 'product-recommendations-slider[data-recommendations-url]';
    const recommendationObservers = new WeakMap();

    const nextFrame = () => new Promise((resolve) => window.requestAnimationFrame(resolve));

    const waitForSplideManager = async () => {
      for (let attempt = 0; attempt < 120; attempt += 1) {
        if (window.SplideManager?.init) return window.SplideManager;
        await nextFrame();
      }

      return null;
    };

    const initializeLoadedRecommendations = async (container) => {
      const slider = container?.querySelector?.(selector);
      if (!slider) return;

      if (typeof window.loadProductManager === 'function') {
        try {
          await window.loadProductManager();
        } catch (error) {
          console.error('[ProductRecommendationsSlider] Product manager failed to load:', error);
        }
      }

      window.ProductManager?.init?.(container);

      const splideManager = await waitForSplideManager();
      if (splideManager?.destroy) {
        splideManager.destroy(container);
      } else if (slider.splide) {
        slider.splide.destroy();
        delete slider.splide;
      }

      splideManager?.init?.(container);

      window.requestAnimationFrame(() => {
        slider.splide?.refresh?.();
        updateProgressVisibility(container);
      });

      window.setTimeout(() => {
        slider.splide?.refresh?.();
        updateProgressVisibility(container);
      }, 160);
    };

    const updateProgressVisibility = (scope = document) => {
      const sliders = scope.matches?.(selector)
        ? [scope]
        : Array.from(scope.querySelectorAll?.(selector) || []);

      sliders.forEach((slider) => {
        const progress = slider.closest('.productSlider')?.querySelector('[data-product-slider-progress]');
        const track = slider.querySelector('.splide__track');
        const list = slider.querySelector('.splide__list');

        if (!progress || !track || !list) return;

        const hasOverflow = slider.classList.contains('is-overflow') || list.scrollWidth > track.clientWidth + 1;

        if (!hasOverflow) {
          progress.setAttribute('hidden', 'hidden');
        } else {
          progress.removeAttribute('hidden');
        }
      });
    };

    const loadRecommendations = async (container) => {
      if (!container || container.dataset.loaded === 'true' || container.dataset.loading === 'true') return;
      if (!container.dataset.productId) return;

      container.dataset.loading = 'true';

      try {
        const response = await fetch(container.dataset.recommendationsUrl, {
          cache: 'no-store',
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html',
          },
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const incoming = doc.querySelector(recommendationsSelector);
        const sourceList = incoming?.querySelector('.productSlider__list');

        if (!incoming || !sourceList) return;

        const directSlides = Array.from(sourceList.children).filter((node) => node.classList?.contains('productSlider__slide'));
        const incomingSlides = directSlides.length > 1
          ? directSlides
          : Array.from(sourceList.querySelectorAll('.productSlider__slide'));
        if (!incomingSlides.length) return;

        const normalizedSlides = incomingSlides.map((sourceSlide) => {
          const slide = sourceSlide.cloneNode(true);
          slide.querySelectorAll('.productSlider__slide').forEach((nestedSlide) => nestedSlide.remove());
          return slide;
        });

        container.innerHTML = incoming.innerHTML;
        const targetList = container.querySelector('.productSlider__list');
        if (!targetList) return;

        normalizedSlides.forEach((slide, index) => {
          slide.dataset.splideSlideIndex = String(index);
        });

        targetList.replaceChildren(...normalizedSlides);
        container.dataset.recommendationCount = String(normalizedSlides.length);
        container.dataset.loaded = 'true';
        await initializeLoadedRecommendations(container);
      } catch (error) {
        console.error('[ProductRecommendationsSlider] Recommendations request failed:', error);
      } finally {
        container.dataset.loading = 'false';
      }
    };

    const observeRecommendations = (container) => {
      if (!container || recommendationObservers.has(container)) return;

      if (window.Shopify?.designMode || typeof window.IntersectionObserver === 'undefined') {
        loadRecommendations(container);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        observer.disconnect();
        recommendationObservers.delete(container);
        loadRecommendations(container);
      }, { rootMargin: '800px 0px' });

      recommendationObservers.set(container, observer);
      observer.observe(container);
    };

    const initRecommendations = (scope = document) => {
      const containers = scope.matches?.(recommendationsSelector)
        ? [scope]
        : Array.from(scope.querySelectorAll?.(recommendationsSelector) || []);

      containers.forEach(observeRecommendations);
    };

    const boot = () => {
      initRecommendations();
      window.setTimeout(() => updateProgressVisibility(), 0);
      window.addEventListener('resize', () => {
        window.setTimeout(() => updateProgressVisibility(), 0);
      });
      document.addEventListener('shopify:section:load', (event) => {
        initRecommendations(event.target);
        window.setTimeout(() => updateProgressVisibility(event.target), 0);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.productSlider .splide[data-splide-component="product-slider"]';

    const updateProgressVisibility = (scope = document) => {
      const sliders = scope.matches?.(selector)
        ? [scope]
        : Array.from(scope.querySelectorAll?.(selector) || []);

      sliders.forEach((slider) => {
        const progress = slider.closest('.productSlider')?.querySelector('[data-product-slider-progress]');
        const track = slider.querySelector('.splide__track');
        const list = slider.querySelector('.splide__list');

        if (!progress || !track || !list) return;

        const hasOverflow = slider.classList.contains('is-overflow') || list.scrollWidth > track.clientWidth + 1;

        if (!hasOverflow) {
          progress.setAttribute('hidden', 'hidden');
        } else {
          progress.removeAttribute('hidden');
        }
      });
    };

    const boot = () => {
      window.setTimeout(() => updateProgressVisibility(), 0);
      window.addEventListener('resize', () => {
        window.setTimeout(() => updateProgressVisibility(), 0);
      });
      document.addEventListener('shopify:section:load', (event) => {
        window.setTimeout(() => updateProgressVisibility(event.target), 0);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"] && !Shopify.designMode) return;
  try {
    
    (() => {
      document.querySelectorAll('[data-search-page]').forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        const body = document.body;
        const filterShell = root.querySelector('[data-search-filter-shell]');
        const filterOpen = root.querySelector('[data-search-filter-open]');
        const filterCloseButtons = root.querySelectorAll('[data-search-filter-close]');
        const sortToggle = root.querySelector('[data-search-sort-toggle]');
        const sortPanel = root.querySelector('[data-search-sort-panel]');
        const sortInput = root.querySelector('[data-search-sort-input]');
        const filterForm = root.querySelector('form[id^="SearchFiltersForm-"]');
        let filterController;

        const openFilter = () => {
          if (!filterShell) return;
          filterShell.hidden = false;
          body.style.overflow = 'hidden';
        };

        const closeFilter = () => {
          if (!filterShell) return;
          filterShell.hidden = true;
          body.style.overflow = '';
        };

        const closeSort = () => {
          if (!sortPanel || !sortToggle) return;
          sortPanel.hidden = true;
          sortToggle.setAttribute('aria-expanded', 'false');
        };

        const openSort = () => {
          if (!sortPanel || !sortToggle) return;
          sortPanel.hidden = false;
          sortToggle.setAttribute('aria-expanded', 'true');
        };

        const DISCOUNT_SORT_VALUE = 'discount-descending';
        const DISCOUNT_ORDER_VIEW = 'discount-order';
        const DISCOUNT_CARDS_VIEW = 'discount-cards';
        const DISCOUNT_ORDER_CONCURRENCY = 6;
        const DISCOUNT_ORDER_PAGE_LIMIT = 40;
        const DISCOUNT_BATCH_SIZE = 20;
        const DISCOUNT_ORDER_CACHE_TTL = 300000;

        let isDiscountSorting = false;
        let isRenderingDiscountBatch = false;
        let discountOrder = [];
        let discountCursor = 0;
        let discountRunId = 0;
        let discountObserver = null;

        const hoistStylesheets = (scope) => {
          if (!scope) return;

          const headHrefs = new Set(
            Array.from(document.head.querySelectorAll('link[rel="stylesheet"]')).map((link) => link.getAttribute('href'))
          );

          scope.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
            const href = link.getAttribute('href');
            if (!href) return;

            if (headHrefs.has(href)) {
              link.remove();
              return;
            }

            headHrefs.add(href);
            document.head.appendChild(link);
          });
        };

        const isDiscountSortSelected = () => {
          try {
            return new URL(window.location.href).searchParams.get('sort_by') === DISCOUNT_SORT_VALUE;
          } catch (_error) {
            return false;
          }
        };

        const syncDiscountSortState = () => {
          const isSelected = isDiscountSortSelected();

          if (isSelected && sortInput) sortInput.value = DISCOUNT_SORT_VALUE;

          root.querySelectorAll('[data-search-sort-option]').forEach((option) => {
            const isDiscountOption = option.dataset.value === DISCOUNT_SORT_VALUE;

            if (isSelected) {
              option.classList.toggle('is-active', isDiscountOption);
            } else if (isDiscountOption) {
              option.classList.remove('is-active');
            }
          });

          return isSelected;
        };

        const getDiscountBaseUrl = () => {
          const url = new URL(window.location.href);
          url.searchParams.delete('page');
          url.searchParams.delete('sort_by');
          url.searchParams.delete('view');
          return url;
        };

        const getDiscountOrderCacheKey = () => {
          const url = getDiscountBaseUrl();
          url.searchParams.sort();
          return `search-discount-order-v1:${url.pathname}?${url.searchParams.toString()}`;
        };

        const readDiscountOrderCache = () => {
          try {
            const cached = JSON.parse(sessionStorage.getItem(getDiscountOrderCacheKey()));
            if (!cached || Date.now() - cached.createdAt > DISCOUNT_ORDER_CACHE_TTL) return null;
            return Array.isArray(cached.order) ? cached.order : null;
          } catch (_error) {
            return null;
          }
        };

        const writeDiscountOrderCache = (order) => {
          try {
            sessionStorage.setItem(getDiscountOrderCacheKey(), JSON.stringify({ order, createdAt: Date.now() }));
          } catch (_error) {
            return;
          }
        };

        const fetchDiscountOrderPage = async (page) => {
          const url = getDiscountBaseUrl();
          url.searchParams.set('view', DISCOUNT_ORDER_VIEW);
          url.searchParams.set('page', String(page));

          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          return JSON.parse((await response.text()).trim());
        };

        const fetchDiscountOrder = async (runId) => {
          const cachedOrder = readDiscountOrderCache();
          if (cachedOrder) return cachedOrder;

          const firstPage = await fetchDiscountOrderPage(1);
          if (runId !== discountRunId) return [];

          const items = firstPage.items || [];
          const totalPages = Math.min(firstPage.pages || 1, DISCOUNT_ORDER_PAGE_LIMIT);
          const pendingPages = [];

          for (let page = 2; page <= totalPages; page += 1) {
            pendingPages.push(page);
          }

          for (let index = 0; index < pendingPages.length; index += DISCOUNT_ORDER_CONCURRENCY) {
            const batch = pendingPages.slice(index, index + DISCOUNT_ORDER_CONCURRENCY);
            const orderPages = await Promise.all(batch.map((page) => fetchDiscountOrderPage(page)));

            if (runId !== discountRunId) return [];

            orderPages.forEach((orderPage) => items.push(...(orderPage.items || [])));
          }

          const order = items
            .map((item, index) => ({ h: item.h, d: item.d, i: index }))
            .sort((a, b) => (b.d - a.d) || (a.i - b.i));

          writeDiscountOrderCache(order);

          return order;
        };

        const fetchDiscountCards = async (handles) => {
          const shopRoot = window.Shopify?.routes?.root || '/';
          const url = new URL(`${shopRoot}search`.replace(/\/{2,}/g, '/'), window.location.origin);

          url.searchParams.set('q', handles.join(' '));
          url.searchParams.set('type', 'product');
          url.searchParams.set('view', DISCOUNT_CARDS_VIEW);

          const response = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          return response.text();
        };

        const removeDiscountTrigger = () => {
          discountObserver?.disconnect();
          root.querySelector('[data-discount-more]')?.remove();
        };

        const observeDiscountTrigger = () => {
          discountObserver?.disconnect();

          const trigger = root.querySelector('[data-discount-more]');
          if (!trigger) return;

          discountObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) renderNextDiscountBatch();
            });
          }, { rootMargin: '400px' });

          discountObserver.observe(trigger);
        };

        const renderDiscountTrigger = () => {
          const results = root.querySelector('[data-search-results-container]');
          if (!results) return;

          let pagination = results.querySelector('[data-search-pagination]');

          if (!pagination) {
            pagination = document.createElement('nav');
            results.appendChild(pagination);
          }

          pagination.className = 'searchPage__pagination';
          pagination.setAttribute('data-search-pagination', '');
          pagination.innerHTML = '<div class="searchPage__infiniteScroll" data-discount-more><span class="searchPage__spinner"></span></div>';

          observeDiscountTrigger();
        };

        const renderNextDiscountBatch = async () => {
          if (isRenderingDiscountBatch) return;
          if (!isDiscountSorting) return;

          if (discountCursor >= discountOrder.length) {
            removeDiscountTrigger();
            return;
          }

          const grid = root.querySelector('.searchPage__grid');
          if (!grid) return;

          const runId = discountRunId;
          const batch = discountOrder.slice(discountCursor, discountCursor + DISCOUNT_BATCH_SIZE);

          isRenderingDiscountBatch = true;
          root.querySelector('[data-discount-more]')?.classList.add('is-loading');

          try {
            const html = await fetchDiscountCards(batch.map((entry) => entry.h));
            if (runId !== discountRunId) return;

            const doc = new DOMParser().parseFromString(html, 'text/html');

            hoistStylesheets(doc);

            doc.querySelectorAll('[data-product-card]').forEach((card) => {
              const gridItem = document.createElement('div');
              gridItem.className = 'searchPage__gridItem';
              gridItem.appendChild(card);
              grid.appendChild(gridItem);
            });

            discountCursor += batch.length;

            if (discountCursor >= discountOrder.length) removeDiscountTrigger();

            document.dispatchEvent(new CustomEvent('search:updated', {
              detail: { action: 'discount-sort' },
            }));
          } catch (error) {
            console.error('[Search] Discount card render failed:', error);
          } finally {
            isRenderingDiscountBatch = false;
            root.querySelector('[data-discount-more]')?.classList.remove('is-loading');
          }
        };

        const applyDiscountSort = async () => {
          const grid = root.querySelector('.searchPage__grid');
          if (!grid) return;

          if (Number.parseInt(grid.dataset.plpCurrentPage || '1', 10) > 1) {
            const firstPageUrl = new URL(window.location.href);
            firstPageUrl.searchParams.delete('page');
            window.location.replace(firstPageUrl.toString());
            return;
          }

          const runId = ++discountRunId;

          isDiscountSorting = true;
          discountOrder = [];
          discountCursor = 0;
          root.classList.add('is-discount-sorting');

          try {
            const order = await fetchDiscountOrder(runId);

            if (runId !== discountRunId) return;
            if (order.length === 0) return;

            discountOrder = order;

            hoistStylesheets(grid);
            grid.replaceChildren();

            renderDiscountTrigger();
            await renderNextDiscountBatch();
          } catch (error) {
            console.error('[Search] Discount sort failed:', error);
          } finally {
            if (runId === discountRunId) {
              root.classList.remove('is-discount-sorting');
            }
          }
        };

        const applySearchFilters = async ({ closeDrawerAfter = false } = {}) => {
          if (!filterForm) return;

          filterController?.abort();
          const controller = new AbortController();
          filterController = controller;

          const url = new URL(filterForm.action, window.location.origin);
          const params = new URLSearchParams();

          new FormData(filterForm).forEach((value, key) => {
            if (key.indexOf('filter.') === 0 && String(value).trim() === '') return;
            params.append(key, value);
          });

          url.search = params.toString();
          root.classList.add('is-loading');
          isDiscountSorting = false;
          discountRunId += 1;
          discountObserver?.disconnect();

          try {
            const response = await fetch(url, {
              signal: controller.signal,
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const text = await response.text();
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const incomingResults = doc.querySelector('[data-search-results-container]');
            const currentResults = root.querySelector('[data-search-results-container]');

            if (!incomingResults || !currentResults) throw new Error('Search results container not found');

            currentResults.replaceWith(incomingResults);

            const currentActiveFilters = root.querySelector('.searchPage__activeFilters');
            const incomingActiveFilters = doc.querySelector('.searchPage__activeFilters');
            const toolbar = filterForm.querySelector('.searchPage__toolbar');

            if (currentActiveFilters && incomingActiveFilters) {
              currentActiveFilters.replaceWith(incomingActiveFilters);
            } else if (currentActiveFilters) {
              currentActiveFilters.remove();
            } else if (incomingActiveFilters && toolbar) {
              toolbar.after(incomingActiveFilters);
            }

            const currentCount = root.querySelector('[data-search-count]');
            const incomingCount = doc.querySelector('[data-search-count]');
            if (currentCount && incomingCount) currentCount.replaceWith(incomingCount);

            window.history.pushState({}, '', url.toString());
            initSearchInfiniteScroll();
            document.dispatchEvent(new CustomEvent('search:updated', {
              detail: { action: 'filter', url: url.toString() },
            }));

            if (syncDiscountSortState()) applyDiscountSort();

            if (closeDrawerAfter) closeFilter();
          } catch (error) {
            if (error.name !== 'AbortError') {
              console.error('[Search] Filter request failed:', error);
            }
          } finally {
            if (filterController === controller) {
              root.classList.remove('is-loading');
            }
          }
        };

        filterOpen?.addEventListener('click', openFilter);
        filterCloseButtons.forEach((button) => button.addEventListener('click', closeFilter));

        sortToggle?.addEventListener('click', () => {
          if (!sortPanel) return;
          if (sortPanel.hidden) {
            openSort();
          } else {
            closeSort();
          }
        });

        root.querySelectorAll('[data-search-sort-option]').forEach((button) => {
          button.addEventListener('click', () => {
            if (!sortInput || !filterForm) return;
            sortInput.value = button.dataset.value || '';
            filterForm.submit();
          });
        });

        filterForm?.addEventListener('submit', (event) => {
          event.preventDefault();
          applySearchFilters({ closeDrawerAfter: true });
        });

        filterForm?.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            applySearchFilters();
          });
        });

        const syncPriceFilter = (filter, sourceInput = null) => {
          const minRange = filter.querySelector('[data-price-min-range]');
          const maxRange = filter.querySelector('[data-price-max-range]');
          const minInput = filter.querySelector('[data-price-min-input]');
          const maxInput = filter.querySelector('[data-price-max-input]');
          const minLabel = filter.querySelector('[data-price-min-label]');
          const maxLabel = filter.querySelector('[data-price-max-label]');
          const slider = filter.querySelector('.searchPage__priceSlider');

          if (!minRange || !maxRange || !minInput || !maxInput || !minLabel || !maxLabel || !slider) return;

          const absoluteMin = Number.parseFloat(filter.dataset.min || minRange.min || '0');
          const absoluteMax = Number.parseFloat(filter.dataset.max || maxRange.max || '0');
          const availableMin = Number.parseFloat(filter.dataset.availableMin || absoluteMin);
          const availableMax = Number.parseFloat(filter.dataset.availableMax || absoluteMax);

          if (!Number.isFinite(absoluteMin) || !Number.isFinite(absoluteMax) || absoluteMax < absoluteMin) return;

          let minValue = Number.parseFloat(minRange.value);
          let maxValue = Number.parseFloat(maxRange.value);

          if (!Number.isFinite(minValue)) minValue = absoluteMin;
          if (!Number.isFinite(maxValue)) maxValue = absoluteMax;

          if (sourceInput === minRange && minValue > maxValue) {
            maxValue = minValue;
          }

          if (sourceInput === maxRange && maxValue < minValue) {
            minValue = maxValue;
          }

          minValue = Math.max(absoluteMin, Math.min(minValue, absoluteMax));
          maxValue = Math.max(absoluteMin, Math.min(maxValue, absoluteMax));

          minRange.value = String(minValue);
          maxRange.value = String(maxValue);

          const rangeSpan = Math.max(absoluteMax - absoluteMin, 0);
          const epsilon = 0.005;
          const isStaticRange = rangeSpan <= epsilon;
          const isTightRange = !isStaticRange && rangeSpan <= Math.max(absoluteMax * 0.03, 5);

          minInput.value = minValue - availableMin > epsilon ? minValue.toFixed(2) : '';
          maxInput.value = availableMax - maxValue > epsilon ? maxValue.toFixed(2) : '';

          const start = isStaticRange ? 0 : ((minValue - absoluteMin) / rangeSpan) * 100;
          const end = isStaticRange ? 100 : ((maxValue - absoluteMin) / rangeSpan) * 100;

          slider.style.setProperty('--price-start', `${start}%`);
          slider.style.setProperty('--price-end', `${end}%`);
          slider.classList.toggle('is-static', isStaticRange);
          slider.classList.toggle('is-tight', isTightRange || isStaticRange);

          minRange.disabled = isStaticRange;
          maxRange.disabled = isStaticRange;

          const locale = filter.dataset.locale || 'pt-BR';
          const currency = filter.dataset.currency || 'BRL';
          const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          minLabel.textContent = formatter.format(minValue);
          maxLabel.textContent = formatter.format(maxValue);
        };

        let priceApplyTimer;

        filterForm?.addEventListener('input', (event) => {
          const priceFilter = event.target.closest('[data-price-filter]');
          if (!priceFilter) return;
          if (!event.target.matches('[data-price-min-range], [data-price-max-range]')) return;

          syncPriceFilter(priceFilter, event.target);
          window.clearTimeout(priceApplyTimer);
          priceApplyTimer = window.setTimeout(() => {
            applySearchFilters();
          }, 220);
        });

        filterForm?.querySelectorAll('[data-price-filter]').forEach((priceFilter) => {
          syncPriceFilter(priceFilter);
        });

        document.addEventListener('click', (event) => {
          if (!sortPanel || !sortToggle) return;
          if (sortPanel.hidden) return;
          if (sortPanel.contains(event.target) || sortToggle.contains(event.target)) return;
          closeSort();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closeFilter();
            closeSort();
          }
        });

        const initSearchInfiniteScroll = () => {
          const trigger = document.querySelector('.searchPage__infiniteScroll[data-infinite-scroll]');
          if (!trigger) return;
          
          let isLoading = false;
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !isLoading && !isDiscountSorting) {
                const url = trigger.dataset.nextUrl;
                if (!url) return;
                
                isLoading = true;
                trigger.classList.add('is-loading');
                
                fetch(url)
                  .then(res => res.text())
                  .then(text => {
                    const doc = new DOMParser().parseFromString(text, 'text/html');
                    
                    const newGrid = doc.querySelector('.searchPage__grid');
                    const currentGrid = document.querySelector('.searchPage__grid');
                    if (newGrid && currentGrid) {
                      Array.from(newGrid.children).forEach(child => currentGrid.appendChild(child));
                    }
                    
                    const newPagination = doc.querySelector('.searchPage__pagination');
                    const currentPagination = document.querySelector('.searchPage__pagination');
                    if (newPagination && currentPagination) {
                      currentPagination.replaceWith(newPagination);
                    }
                    
                     isLoading = false;
                     observer.disconnect();
                     initSearchInfiniteScroll();
                     document.dispatchEvent(new CustomEvent('search:updated', {
                       detail: { action: 'pagination', url },
                     }));
                  })
                  .catch(err => {
                    console.error('[Search] Infinite scroll error:', err);
                    isLoading = false;
                    trigger.classList.remove('is-loading');
                  });
              }
            });
          }, { rootMargin: '400px' });
          
          observer.observe(trigger);
        };
        
        initSearchInfiniteScroll();

        if (syncDiscountSortState()) applyDiscountSort();
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
